const DAY_PREFIX = /^(\d{4})-(\d{2})-(\d{2})/;
const BARE_DAY = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * Local midnight for a calendar day, or null when the day does not exist
 * (`2026-02-31`). `new Date(y, m, d)` rolls an impossible day into the next
 * month, so a Date that does not read back as its own parts is rejected.
 * `new Date('YYYY-MM-DD')` is UTC midnight and shifts the day west of UTC.
 */
function localMidnight(m: RegExpExecArray): Date | null {
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const parsed = new Date(y, mo - 1, d);
  return parsed.getFullYear() === y && parsed.getMonth() + 1 === mo && parsed.getDate() === d ? parsed : null;
}

/** A value that STARTS with `YYYY-MM-DD` (a Postgres DATE on the wire, bare or `…T00:00:00.000Z`) as that day's local midnight. */
export function parseCalendarDay(value: string): Date | null {
  const m = DAY_PREFIX.exec(value);
  return m ? localMidnight(m) : null;
}

/** Only a bare `YYYY-MM-DD`. A timestamp is an instant, not a day, so it returns null. */
export function parseBareCalendarDay(value: string): Date | null {
  const m = BARE_DAY.exec(value);
  return m ? localMidnight(m) : null;
}
